import WishlistAvailabilityModal from "@dana/Components/MyList/MyListEmergencyFlow";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import loadWishlistavAilability from "@dana/Store/Data/WishlistAvailability/Handlers/WishlistAvailabilityHandler";
import { WishlistAvailabilityActions } from "@dana/Store/Data/WishlistAvailability/Reducers/WishlistAvailabilityReducer";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import { getWishListLines, ShareOptions } from "@insite/client-framework/Services/WishListService";
import { getLanguages, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { LanguageModel, WishListLineModel, WishListModel } from "@insite/client-framework/Types/ApiModels";
import MyListsDetailsPageTypeLink from "@insite/content-library/Components/MyListsDetailsPageTypeLink";
import WishListSharingStatus, {
    WishListSharingStatusStyles,
} from "@insite/content-library/Components/WishListSharingStatus";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Star from "@insite/mobius/Icons/Star";
import StarX from "@insite/mobius/Icons/StarX";
import Tag from "@insite/mobius/Icons/Tag";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import OverflowMenu, { OverflowMenuPresentationProps } from "@insite/mobius/OverflowMenu";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { useContext, useEffect, useRef, useState } from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import { addDanaWishListToCart, danaBatchCheck } from "@dana/Overrides/Services/CartService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { LARegion } from "@dana/Common/Constants";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import DanaOrderUpload from "@dana/Components/DanaOrderUpload/DanaOrderUpload";
import addToWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import loadWishListIfNeeded from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListIfNeeded";
import useIsEmea from "@dana/Common/Hooks/useIsEmea";
import UploadItemsToList from "@dana/Overrides/Widgets/MyListsDetails/UploadItemsToList";
import { getDanaGeneralSettings } from "@dana/Store/Context/ContextSelectors";
import usePollConfig from "@dana/Common/Hooks/usePollConfig";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";


const mapStateToProps = (state: ApplicationStateDana) => ({
    currentLanguage: state.context.session.language,
    languages: getLanguages(state),
    language: state.context.session.language,
    allowEditingOfWishLists: getSettingsCollection(state).wishListSettings.allowEditingOfWishLists,
    isUpdatingCart: state.context.isUpdatingCart,
    wishlistAvailability: state.wishlistAvailabilityState,
    cartPageLink: getPageLinkByPageType(state, "CartPage"),
    isEmea: useIsEmea(state),
    danaGeneralSettings: getDanaGeneralSettings(state)
});
const mapDispatchToProps = {
    loadWishlistavAilability,
    loadCurrentCart,
    addToWishList,
    loadWishListIfNeeded

};
interface OwnProps {
    key: string
    wishList: WishListModel;
    extendedStyles?: WishListCardStyles;
    deleteWishList?: () => void;
    leaveWishList?: () => void;
    toggleFavorite?: () => void;
    toggleHide?: () => void;
}

type Props = OwnProps &

    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasHistory &
    DispatchProp<WishlistAvailabilityActions>;

export interface WishListCardStyles {
    gridContainer?: GridContainerProps;
    wishListInfoGridItem?: GridItemProps;
    wishListInfoGridContainer?: GridContainerProps;
    basicInfoGridItem?: GridItemProps;
    basicInfoGridContainer?: GridContainerProps;
    detailLinkGridItem?: GridItemProps;
    descriptionGridItem?: GridItemProps;
    descriptionText?: TypographyProps;
    lastUpdatedGridItem?: GridItemProps;
    lastUpdatedText?: TypographyProps;
    extendedInfoGridItem?: GridItemProps;
    extendedInfoGridContainer?: GridContainerProps;
    productImagesGridItem?: GridItemProps;
    productImageLink?: LinkPresentationProps;
    productImage?: LazyImageProps;
    sharingStatusGridItem?: GridItemProps;
    sharingStatus?: WishListSharingStatusStyles;
    actionGridItem?: GridItemProps;
    actionGridMediumHidden?: HiddenProps;
    actionOverflowIcon?: IconPresentationProps;
    actionOverflowMenu?: OverflowMenuPresentationProps;
    actionAddToCartClickable?: ClickablePresentationProps;
    actionHideClickable?: ClickablePresentationProps;
    actionDeleteClickable?: ClickablePresentationProps;
    actionLeaveClickable?: ClickablePresentationProps;
    actionAddToCartButton?: ButtonPresentationProps;
    actionHideLink?: LinkPresentationProps;
    actionDeleteButton?: ButtonPresentationProps;
    actionLeaveButton?: ButtonPresentationProps;
    actionFavoriteClickable?: ClickablePresentationProps;
    basicIconGridContainer?: GridContainerProps;
    detailIconGridItem?: GridItemProps;
    starIcon?: IconPresentationProps;
    starXIcon?: IconPresentationProps;
    tagTooltip?: TooltipPresentationProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    uploadItemsButton?: ButtonPresentationProps;
    uploadItemsModal?: ModalPresentationProps;
}

export const wishListCardStyles: WishListCardStyles = {
    gridContainer: {
        gap: 5,
    },
    wishListInfoGridItem: {
        width: [10, 10, 8, 10, 10],
        align: "middle",
    },
    basicInfoGridItem: { width: [12, 12, 5, 4, 4] },
    basicInfoGridContainer: {
        gap: 10,
        css: css`
            margin-left: 10px;
        `,
    },
    detailLinkGridItem: { width: 12 },
    descriptionGridItem: { width: 12 },
    descriptionText: { ellipsis: true },
    lastUpdatedGridItem: { width: 12 },
    extendedInfoGridItem: {
        width: [12, 12, 7, 8, 8],
        align: "middle",
    },
    productImageLink: {
        css: css`
            margin-right: 5px;
        `,
    },
    productImagesGridItem: {
        width: [12, 12, 12, 8, 8],
        css: css`
            flex-wrap: wrap;
        `,
    },
    productImage: {
        css: css`
            max-width: 75px;
            img {
                height: 100%;
            }
        `,
        errorTypographyProps: {
            size: 11,
            css: css`
                max-height: 65px;
            `,
        },
    },
    sharingStatusGridItem: { width: [12, 12, 12, 4, 4] },
    actionGridItem: {
        width: [2, 2, 4, 2, 2],
        align: "top",
        css: css`
            justify-content: flex-end;
            
            [class*="Hidden"] {
                button span {
                    padding: 0;
                    text-align: left;
                }
            }
        `,
    },
    actionGridMediumHidden: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 8px;
            width: 100%;
        `,
    },
    actionAddToCartButton: {
        variant: "primary",
        color: "secondary",
        css: css`
            width: 100%;
            padding: 0 10px;
        `,
    },
    actionHideLink: {
        css: css`
            display: block;
            margin: 10px auto 0 auto;
        `,
    },
    actionDeleteButton: {
        variant: "secondary",
        css: css`
            width: 100%;
            margin-top: 10px;
        `,
    },
    actionLeaveButton: {
        variant: "secondary",
        css: css`
            width: 100%;
            margin-top: 10px;
        `,
    },
    sharingStatus: {
        privateTooltip: {
            cssOverrides: {
                tooltipContainer: css`
                    transform: translateX(-33%);
                `,
                tooltipArrow: css`
                    left: 33%;
                `,
            },
        },
    },
    basicIconGridContainer: {
        gap: 10,
        css: css`
            width: 15px;
            flex-shrink: 0;
        `,
        offsetCss: css`
            flex-direction: column;
        `,
    },
    actionFavoriteClickable: {
        css: css`
            width: 15px;
        `,
    },
    starIcon: {
        src: Star,
        size: 15,
    },
    starXIcon: {
        src: StarX,
        size: 15,
    },
    tagTooltip: {
        iconProps: {
            src: Tag,
            size: 15,
            css: css`
                margin: 4px 0;
            `,
        },
    },
    centeringWrapper: {
        css: css`
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: 0 auto;
        `,
    },
    uploadItemsButton: {
        variant: "secondary",
        css: css`
            width: 100%;
            margin-top: 10px;
        `,
    },
    uploadItemsModal: {
        sizeVariant: "large",
        cssOverrides: {
            modalTitle: css`
                padding: 10px 28px;
            `,
            modalContent: css`
                padding: 0;
            `,
        },
    },
};

const WishListCard = ({
    language,
    allowEditingOfWishLists,
    isUpdatingCart,
    extendedStyles,
    wishList,
    deleteWishList,
    leaveWishList,
    toggleFavorite,
    toggleHide,
    wishlistAvailability,
    loadWishlistavAilability,
    languages,
    currentLanguage,
    cartPageLink,
    addToWishList,
    danaGeneralSettings,
    isEmea,
    history
}: Props) => {

    const toasterContext = useContext(ToasterContext);
    const isLoadingAnyList = useAppSelector(state => Object.keys(state.data.wishLists.isLoading).length > 0);
    const [isUpdatingDanaCart, setIsUpdatingDanaCart] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState<LanguageModel>();
    const [listLines, setListLines] = useState<WishListLineModel[] | null>();
    const [uploadModalIsOpen, setUploadModalIsOpen] = useState(false);
    const [isPolling, setIsPolling] = useState(false);
    const pollIntervalRef = useRef<NodeJS.Timeout | null>(null);
    const pollTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const { pollIntervalMs, pollTimeoutMs } = usePollConfig();
    const [downloadTemplate, setTemplate] = useState("");
    const [linesCount, setLinesCount] = useState(0);
    useEffect(() => {
        if (isEmea) {
            setTemplate("/userfiles/ListUploadEmeaTemplate.xlsx");
        } else {
            setTemplate("/userfiles/ListUploadTemplate.xlsx");
        }
    }, [isEmea]);

    useEffect(() => {
        return () => { stopPolling(); };
    }, []);
    useEffect(() => {
        setLinesCount(parseInt(wishList?.properties['lineCount'], 10))
    }, [wishList])
    const stopPolling = () => {
        if (pollIntervalRef.current) { clearInterval(pollIntervalRef.current); pollIntervalRef.current = null; }
        if (pollTimeoutRef.current) { clearTimeout(pollTimeoutRef.current); pollTimeoutRef.current = null; }
        setIsPolling(false);
    };

    const startPolling = () => {
        if (pollIntervalRef.current) return;
        setIsPolling(true);
        pollIntervalRef.current = setInterval(() => {
            danaBatchCheck('').then(result => {
                if (result.success) {
                    stopPolling();
                    toasterContext.addToast({ body: `${translate("List Added to Cart")}`, messageType: "success" });
                    setIsUpdatingDanaCart(false);
                    if (cartPageLink) {
                        history.push(cartPageLink.url);
                    }
                }
            }).catch(() => { /* continue polling on transient errors */ });
        }, pollIntervalMs);

        pollTimeoutRef.current = setTimeout(() => {
            stopPolling();
            toasterContext.addToast({
                body: translate("Error adding items to the cart."),
                messageType: "warning",
                isFocusAfterMount: true,
            });
        }, pollTimeoutMs);
    };

    useEffect(() => {
        setListLines(wishList.wishListLineCollection)

    }, [wishList.wishListLineCollection]);
    useEffect(() => {
        const lang = languages?.find(l => l.id === currentLanguage?.id);
        setSelectedLanguage(lang)

    }, [currentLanguage]);

    const clickAddToCartHandler = (e: any) => {
        e.preventDefault();
        setIsUpdatingDanaCart(true);

        addDanaWishListToCart(wishList.id).then(() => {
            if (danaGeneralSettings && linesCount >= parseInt(danaGeneralSettings.largeCartItemsThresholdBatchSize, 10)) {
                startPolling();
            } else {
                toasterContext.addToast({ body: `${translate("List Added to Cart")}`, messageType: "success" });
                setIsUpdatingDanaCart(false);
                if (cartPageLink) {
                    history.push(cartPageLink.url);
                }
            }
        });
    };

    const updatedOnDisplay = getLocalizedDateTime({
        dateTime: new Date(wishList.updatedOn),
        language,
        options: {
            year: "numeric",
            month: "numeric",
            day: "numeric",
        },
    });
    let lastUpdatedDisplay = `${translate("Updated")} ${updatedOnDisplay}`;
    if (wishList.updatedByDisplayName && !wishList.isAutogenerated) {
        lastUpdatedDisplay += ` ${translate("by")} ${wishList.updatedByDisplayName}`;
    }

    const canAddToCart = wishList.canAddToCart && !!wishList.wishListLinesCount && wishList.wishListLinesCount > 0;
    const addToCartLabel = translate("Add List to Stock Cart");
    const addToEmergencyCartLabel = translate("Add List to Emergency Cart");
    const toggleHideButtonText = wishList.isHidden ? translate("Unhide List") : translate("Hide List");
    const toggleFavoriteLabel = wishList.isFavorite
        ? translate("Remove from favorites")
        : translate("Add to favorites");
    const deleteLabel = translate("Delete");
    const leaveLabel = translate("Leave List");
    const [styles] = React.useState(() => mergeToNew(wishListCardStyles, extendedStyles));

    const loadWishlistavAilabilityHandler = async () => {
        const list = await getWishListLines({ wishListId: wishList.id, pageSize: 500 });
        if (list && list.wishListLines && list.wishListLines.length > 0) {
            loadWishlistavAilability({ wishList, wishListLineCollection: list.wishListLines })
        }
    }

    const uploadProductsHandler = async (products: any[]) => {
        const productInfos = products.map(o => ({
            productId: o.id,
            qtyOrdered: o.qtyOrdered,
            unitOfMeasure: o.selectedUnitOfMeasure ?? "",
            properties: {
                requestedShipDate: o.properties.requestedShipDate,
            } as any,
        }));

        await addToWishList({ productInfos, selectedWishList: wishList });

    };
    return (
        <>

            <GridContainer {...styles.gridContainer} data-test-selector="wishListCard">
                <GridItem {...styles.wishListInfoGridItem} data-test-selector={`${wishList.name}`}>
                    <GridContainer {...styles.wishListInfoGridContainer}>
                        <GridItem {...styles.basicInfoGridItem}>
                            <GridContainer {...styles.basicIconGridContainer}>
                                {!wishList.isAutogenerated && (
                                    <GridItem {...styles.detailIconGridItem}>
                                        <Clickable
                                            {...styles.actionFavoriteClickable}
                                            onClick={toggleFavorite}
                                            aria-label={toggleFavoriteLabel}
                                            data-test-selector={`myListsFavorite_${wishList.id}`}
                                            disabled={isLoadingAnyList}
                                        >
                                            {wishList.isFavorite && (
                                                <Icon
                                                    {...styles.starXIcon}
                                                    data-test-selector={`myListsFavoriteStarXIcon_${wishList.id}`}
                                                />
                                            )}
                                            {!wishList.isFavorite && (
                                                <Icon
                                                    {...styles.starIcon}
                                                    data-test-selector={`myListsFavoriteStarIcon_${wishList.id}`}
                                                />
                                            )}
                                        </Clickable>
                                    </GridItem>
                                )}
                                {wishList.wishListTags && wishList.wishListTags.length > 0 && (
                                    <GridItem
                                        {...styles.detailIconGridItem}
                                        data-test-selector={`myListsTags_${wishList.id}`}
                                    >
                                        <Tooltip
                                            {...styles.tagTooltip}
                                            text={`${translate("Tags Assigned")}: ${wishList.wishListTags
                                                .map(o => o.tag)
                                                .join(", ")}`}
                                        />
                                    </GridItem>
                                )}
                            </GridContainer>
                            <GridContainer {...styles.basicInfoGridContainer}>
                                <GridItem {...styles.detailLinkGridItem}>
                                    <MyListsDetailsPageTypeLink
                                        title={`${wishList.name} (${wishList.properties['lineCount']})`}
                                        wishListId={wishList.id}
                                        testSelector="wishListCardName"
                                    />
                                </GridItem>
                                {wishList.description && (
                                    <GridItem {...styles.descriptionGridItem}>
                                        <Typography
                                            {...styles.descriptionText}
                                            data-test-selector="wishListCardDescription"
                                        >
                                            {wishList.description}
                                        </Typography>
                                    </GridItem>
                                )}
                                <GridItem {...styles.lastUpdatedGridItem}>
                                    <Typography
                                        {...styles.lastUpdatedText}
                                        data-test-selector="wishListCardLastUpdated"
                                    >
                                        {lastUpdatedDisplay}
                                    </Typography>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                        <GridItem {...styles.extendedInfoGridItem}>
                            <GridContainer {...styles.extendedInfoGridContainer}>
                                <GridItem {...styles.productImagesGridItem} data-test-selector="productImagesGridItem">
                                    {wishList.wishListLineCollection &&
                                        wishList.wishListLineCollection.length > 0 &&
                                        wishList.wishListLineCollection.slice(0, 3).map(line => (
                                            <Link
                                                key={line.id.toString()}
                                                {...styles.productImageLink}
                                                href={line.productUri}
                                            >
                                                <LazyImage
                                                    {...styles.productImage}
                                                    src={line.smallImagePath}
                                                    altText={line.altText}
                                                    title={line.altText}
                                                />
                                            </Link>
                                        ))}
                                </GridItem>
                                <GridItem {...styles.sharingStatusGridItem}>
                                    <WishListSharingStatus extendedStyles={styles.sharingStatus} wishList={wishList} />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </GridItem>
                <GridItem {...styles.actionGridItem}>
                    <Hidden above="sm">
                        <OverflowMenu position="end" {...styles.actionOverflowMenu}>
                            <Clickable
                                {...styles.actionAddToCartClickable}
                                disabled={!canAddToCart || isUpdatingCart}
                                onClick={clickAddToCartHandler}
                            >
                                {addToCartLabel}
                            </Clickable>
                            {selectedLanguage && selectedLanguage.properties.region !== LARegion && listLines && (
                                <Clickable
                                    {...styles.actionAddToCartClickable}
                                    disabled={!canAddToCart || isUpdatingCart}
                                    data-test-selector={`wishListAddToCartButton_${wishList.id}`}
                                    onClick={loadWishlistavAilabilityHandler}
                                >
                                    {addToEmergencyCartLabel}
                                </Clickable>
                            )}


                            {danaGeneralSettings?.enableCopyPasteFeatureForMyList ? (
                                <Clickable
                                    {...styles.actionAddToCartClickable}
                                    onClick={() => setUploadModalIsOpen(true)}
                                    data-test-selector={`wishListUploadItemsOverflow_${wishList.id}`}
                                >
                                    {translate("Upload Items")}
                                </Clickable>
                            ) : (
                                <UploadItemsToList
                                    wishList={wishList}
                                    displayTypeButton={true}
                                />
                            )}

                            {!wishList.isAutogenerated && (
                                <Clickable
                                    {...styles.actionHideClickable}
                                    disabled={isLoadingAnyList}
                                    onClick={toggleHide}
                                >
                                    {toggleHideButtonText}
                                </Clickable>
                            )}
                            {allowEditingOfWishLists &&
                                !!deleteWishList &&
                                !wishList.isSharedList &&
                                !wishList.isAutogenerated && (
                                    <Clickable {...styles.actionDeleteClickable} onClick={deleteWishList}>
                                        {deleteLabel}
                                    </Clickable>
                                )}
                            {allowEditingOfWishLists &&
                                !!leaveWishList &&
                                wishList.isSharedList &&
                                wishList.shareOption !== ShareOptions.AllCustomerUsers && (
                                    <Clickable {...styles.actionLeaveClickable} onClick={leaveWishList}>
                                        {leaveLabel}
                                    </Clickable>
                                )}
                        </OverflowMenu>
                    </Hidden>
                    <Hidden {...styles.actionGridMediumHidden} below="md">
                        {isUpdatingDanaCart ? (
                            <StyledWrapper {...styles.centeringWrapper}>
                                <LoadingSpinner {...styles.spinner} />
                            </StyledWrapper>
                        ) : (
                            <></>
                        )}
                        <Button
                            {...styles.actionAddToCartButton}
                            disabled={!canAddToCart || isUpdatingCart}
                            data-test-selector={`wishListAddToCartButton_${wishList.id}`}
                            onClick={clickAddToCartHandler}
                        >
                            {addToCartLabel}
                        </Button>
                        {selectedLanguage && selectedLanguage.properties.region !== LARegion && (
                            <Button
                                {...styles.actionAddToCartButton}
                                disabled={!canAddToCart}
                                data-test-selector={`wishListAddToCartButton_${wishList.id}`}
                                onClick={loadWishlistavAilabilityHandler}
                            >
                                {addToEmergencyCartLabel}
                            </Button>
                        )}
                        {danaGeneralSettings?.enableCopyPasteFeatureForMyList ? (<Button
                            {...styles.uploadItemsButton}
                            onClick={() => setUploadModalIsOpen(true)}
                            data-test-selector={`wishListUploadItemsButton_${wishList.id}`}
                        >
                            {translate("Upload Items")}
                        </Button>) : (<UploadItemsToList
                            wishList={wishList}
                            displayTypeButton={true}
                        />)}

                        {!wishList.isAutogenerated && (
                            <Link
                                {...styles.actionHideLink}
                                onClick={toggleHide}
                                data-test-selector={`myListsHide_${wishList.id}`}
                                disabled={isLoadingAnyList}
                            >
                                {toggleHideButtonText}
                            </Link>
                        )}
                        {allowEditingOfWishLists &&
                            !!deleteWishList &&
                            !wishList.isSharedList &&
                            !wishList.isAutogenerated && (
                                <Button
                                    {...styles.actionDeleteButton}
                                    onClick={deleteWishList}
                                    data-test-selector={`wishListCardDeleteButton_${wishList.id}`}
                                >
                                    {deleteLabel}
                                </Button>
                            )}
                        {allowEditingOfWishLists &&
                            !!leaveWishList &&
                            wishList.isSharedList &&
                            wishList.shareOption !== ShareOptions.AllCustomerUsers && (
                                <Button
                                    {...styles.actionLeaveButton}
                                    onClick={leaveWishList}
                                    data-test-selector={`wishListCardLeaveButton_${wishList.id}`}
                                >
                                    {leaveLabel}
                                </Button>
                            )}
                    </Hidden>
                </GridItem>
            </GridContainer>
            {wishlistAvailability.showPopup && <WishlistAvailabilityModal></WishlistAvailabilityModal>}
            <DanaOrderUpload
                onUploadProducts={uploadProductsHandler}
                templateUrl={downloadTemplate}
                isOpen={uploadModalIsOpen}
                handleClose={() => setUploadModalIsOpen(false)}
                wishListId={wishList.id}
                wishListName={wishList.name}
            />
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(WishListCard));
